import { Flex } from "@chakra-ui/layout";
import React from "react";

export const PageLayout = ({ children }: { children: React.ReactNode }) => {
    const bgImageUrl = `url('${process.env.PUBLIC_URL}/bg.webp')`;
    return (
        <Flex
            as="main"
            flexDirection="column"
            alignItems="center"
            overflowY='auto'
        >
            {/* TODO: This component exists for i18n demo purposes, can be removed when i18n integrated into GCA stuff. */}
            {/* <LanguageSelect /> */}
            {/* background image */}
            <Flex
                // FIXME: IDK why the IDE things this is a problem, but it works fine
                backgroundImage={bgImageUrl}
                backgroundSize="cover"
                backgroundPosition="center"
                height="100vh"
                width="100vw"
                position="absolute"
                filter='blur(10px) brightness(0.5)'
                zIndex={-1}
            >
            </Flex>
            <Flex
                direction='column'
                width='1000px'
                height='100%'
                maxWidth='95%'
                marginY='2rem'
                gap='1rem'
                // Accomodate for the language select
                marginTop='4rem'
            >
                {children}
            </Flex>
        </Flex>
    )
};